<ng-template ngFor let-step let-index="index" [ngForOf]="steps">
  <app-engagement-step-item class="step-item" [step]="step" (click)="goToStep.emit(stepReference(step))">
    <div class="step-index" step-index>{{ index + 1 }}</div>
  </app-engagement-step-item>
</ng-template>
